<div class="SearchFilterButtonContainer Flexbox Justify--right Hidden" [style.grid-column]="gridColumn">
  <button class="SearchButton" mat-icon-button (click)="searchClick()">
    <mat-icon>manage_search</mat-icon>
  </button>
</div>
<div class="FilterContent Flexbox Flexbox--column Gap--smaller" [class.Hidden]="!shouldShow" [class.AnimateIn]="animationDirection === 'In'" [class.AnimateOut]="animationDirection === 'Out'">
  <div class="Flexbox Gap--smaller Align--center">
    <mat-form-field appearance="outline" class="SearchInput">
      <mat-label>{{ placeholder() }}</mat-label>
      <input matInput #search [(ngModel)]="searchText" (blur)="onSearchBlur()" (ngModelChange)="searchTextChange()">
    </mat-form-field>
    <button hidden mat-icon-button (click)="closeClicked()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <!-- <mat-slide-toggle [checked]="shouldShowUnavailable()" (change)="showUnavailableChange($event.checked)">Show Unavailable</mat-slide-toggle> -->
</div>
